import { CommonModule } from "@angular/common";
import { Component, EventEmitter, Inject, Input, Output } from "@angular/core";
import {
  FormBuilder,
  FormControl,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { MatCheckboxModule } from "@angular/material/checkbox";
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogModule,
  MatDialogRef,
} from "@angular/material/dialog";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { MatSelectModule } from "@angular/material/select";
import { select, Store } from "@ngrx/store";
import { AppState } from "../../../../app.state";
import { LoadingService } from "../../../../loading/loading.service";
import { AcuerdosService } from "../../../../services/acuerdos/acuerdos.service";
import { DespachoService } from "../../../../services/despacho/despacho.service";
import { selectUsuario } from "../../../../states/usuario/selector";
import { aplazarTemaMrb } from "../../../../states/acuerdos-mrb/actions";
import {
  IRAplazarTema,
  IRAplazarTemaNotificacion,
} from "../../../../interfaces/acuerdos";
import { IDetalleTema } from "../../../../interfaces/temas";
import { TemasService } from "../../../../services/temas/temas.service";

@Component({
  selector: "app-aplazar-tema",
  standalone: true,
  imports: [
    MatDialogModule,
    MatButtonModule,
    MatFormFieldModule,
    MatSelectModule,
    MatInputModule,
    FormsModule,
    ReactiveFormsModule,
    CommonModule,
    MatCheckboxModule,
  ],
  templateUrl: "./aplazar-tema.component.html",
  styleUrl: "./aplazar-tema.component.css",
})
export class AplazarTemaComponent {
  private readonly stateUser: any = this.store.pipe(select(selectUsuario));
  fecha: any = new FormControl("", [Validators.required]);

  fechasAcuerdo: any[] = [];
  constructor(
    private store: Store<AppState>,
    public dialogRef: MatDialogRef<AplazarTemaComponent>,
    public despachoService: DespachoService,
    public acuerdosService: AcuerdosService,
    public dialog: MatDialog,
    public loadingService: LoadingService,
    public temasService: TemasService,
    @Inject(MAT_DIALOG_DATA)
    public data: any
  ) {}
  ngOnInit(): void {
    this.loadingService.hide();
    this.fechasAcuerdo = this.data.acuerdos;
  }

  async save() {
    this.loadingService.show();
    console.log("fechas seleccionada =>", Object.keys(this.fecha.value));

    console.log("fechas seleccionada =>", Object.values(this.fecha.value));

    const user = structuredClone(this.stateUser.state().usuario);

    const aplazar: IRAplazarTema = {
      id_tema: this.data.id,
      id_acuerdo: this.fecha.value.idFE,
      id_usuario: user.uid,
    };
    const notificacion: IRAplazarTemaNotificacion = {
      nombreUsuario: user.nombre,
      fechaAcuerdoAnterior: this.data.fechaAcuerdo,
      fechaAcuerdoActual: this.fecha.value.fechaAcuerdo ?? "",
      id_categorizacion: this.data.id_categorizacion,
      notificacion: "temaAplazado",
    };

    try {
      const aplazarRes = await this.temasService.aplazarTema(aplazar);
      const notificacionRes = await this.temasService.aplazarTemaNotificacion(
        notificacion
      );

      if (!aplazarRes.error && !notificacionRes.error) {
        this.loadingService.hide();
        this.store.dispatch(aplazarTemaMrb({ aplazar, notificacion }));
      }
    } catch (error) {
      this.loadingService.hide();
    }

    console.log("aplazar", aplazar);
    console.log("notificacion", notificacion);

    //this.store.dispatch(aplazarTemaMrb({ aplazar, notificacion }));
  }
}
